
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wellmaxx/studio/[...slug]",
      function () {
        return require("private-next-pages/wellmaxx/studio/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wellmaxx/studio/[...slug]"])
      });
    }
  